import styled from 'styled-components';

import { flexBetween, flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  overflow: hidden;
  width: max-content;
  height: 585px;
  width: calc(100vw - 32px);
  max-width: 860px;
  ${flexColumn}
`;

export const HeaderWrapper = styled.div`
  ${flexBetween};
  position: relative;
  border-bottom: 1px solid var(--border-main);
  padding: 22px 40px;
`;

export const ContentWrapper = styled.div`
  overflow-y: scroll;
  flex: 1;

  background-color: inherit;

  & [data-type='category'] {
    padding-bottom: 10px;
    padding-inline: 40px;

    & > *:first-child {
      padding: 14px 0px;
    }
  }

  & [data-open='true'] {
    background-color: var(--bg-card);
  }

  & [data-type='categories-filter'] > [data-type='category']:first-child {
    padding-top: 20px;
  }

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    height: 59px;
    border-radius: 7px;
    background-color: #b1b8c6;
  }

  will-change: height;
`;

export const FooterWrapper = styled.div`
  bottom: 0%;
  box-shadow: 10px 0 34px rgba(10, 10, 10, 0.05);
  display: flex;
  gap: 20px;
  padding: 20px 40px;
  position: relative;
  background-color: var(--bg-main);
`;

export const CrossButton = styled.button`
  display: flex;
  background: none;
  border: none;
  border-radius: 50%;
  color: var(--textAndLabels-tertiary);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: var(--system-yellow);
  }

  & svg {
    width: 16px;
    height: 16px;
  }
`;
